import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  reset,
  setArea,
  setDates,
  setModel,
  setModelPeriods,
  setVariable,
  selectMWComparatorControlPanelTriggerFetch,
} from 'redux/reducers/meteorologyWeatherComparatorControlPanelReducer';
import simpleDiffToFormattedDate from 'helper/simpleDiffToFormattedDate';

const MODEL_DATE_FORMAT = 'yyyy-MM-dd';
const PERIOD_DATE_FORMAT = 'yyyy-MM';

export default function useSelectPreference() {
  const [triggerRequest, setTriggerRequest] = useState(false);
  const trigger = useSelector(selectMWComparatorControlPanelTriggerFetch);

  const selectPreferenceTrigger = (preference) => () => {
    const {
      variable,
      area,
      confrontingModel,
      baseModel,
    } = preference.json;

    store.dispatch(reset());
    store.dispatch(setVariable(variable));
    store.dispatch(setModel([confrontingModel.model, baseModel.model]));
    store.dispatch(setModelPeriods([
      {
        startDate: simpleDiffToFormattedDate(confrontingModel.initialDate, PERIOD_DATE_FORMAT),
        endDate: simpleDiffToFormattedDate(confrontingModel.finalDate, PERIOD_DATE_FORMAT),
      },
      {
        startDate: simpleDiffToFormattedDate(baseModel.initialDate, PERIOD_DATE_FORMAT),
        endDate: simpleDiffToFormattedDate(baseModel.finalDate, PERIOD_DATE_FORMAT),
      },
    ]));
    store.dispatch(setDates([
      simpleDiffToFormattedDate(confrontingModel.roundDate, MODEL_DATE_FORMAT),
      simpleDiffToFormattedDate(baseModel.roundDate, MODEL_DATE_FORMAT),
    ]));
    store.dispatch(setArea(area));
    setTriggerRequest(true);
  };

  useEffect(() => {
    if (trigger && triggerRequest) {
      trigger();
      setTriggerRequest(false);
    }
  }, [trigger, triggerRequest, setTriggerRequest]);

  return {
    selectPreferenceTrigger,
  };
}
